/* eslint-disable  react/jsx-no-bind */
/* eslint-disable  react/jsx-key */
/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  no-else-return */
/* eslint-disable import/order */
/* eslint-disable no-await-in-loop */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { MinusOutlined } from '@ant-design/icons';
import { Form as AntForm, Col, Collapse, message, Row, Space, Tree, Typography } from 'antd';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';

import { useDeleteCardholder } from '~/controllers/cardholder';
import { getContacts } from '~/api/contacts';
import colors from '~/constants/colors';
import { PlusIcon } from '~/img';
import { setDeleteNode, setEditedNodeDetails, setEditLeafeNodes, setNodeDetails } from '~/slices/state';
import { Contacts } from '~/types/Contacts';
import { Person } from '~/types/Person';
import { cardholdersValidatior } from '~/utils/cardholder';
import getInitialTree from '~/utils/useGetInitialTree';

import CardHolderEditModal from './components/CardHolderEditModal';
import CardHolderModal from './components/CardHolderModal';
import InputTreeElement from './components/InputTreeElement';
import TreeTitle from './components/TreeTitle';
import SelectInputTree from './SelectInputTree';
import { physicalCards } from '.';

const { Panel } = Collapse;
const TreeChildren: any = (props: any) => {
  const [isError, setIsError] = useState<any>({ value: false, message: '' });
  const globState = useSelector((state: any) => state.state);
  const {
    editCardholderModal,
    nodeDetails,
    editedNodeDetails,
    deleteNode,
    leafNodesHaveNocardholders = {},
    applicationStage,
  } = globState;
  const dispatch = useDispatch();
  const { mutateAsync: deleteCardholder } = useDeleteCardholder();
  const [treeData, setTreeData] = useState([]);
  const [openCardholderModal, setCardholderModal] = useState({ value: false, productKey: '' });
  const [defaultActiveKeys, setDefaultActiveKeys] = useState<any>([]);
  const [defaultTreeKeys, setDefaultTreeKeys] = useState<any>([]);

  const {
    productKey,
    predefiendHierarchy,
    productList,
    setProductsList,
    setCalldraft,
    applicationQuery,
    allProductsLists,
    selectedProducts,
    productLocked,
  } = props;
  const [form] = AntForm.useForm();

  function defaultKeyHandler(value: any) {
    setDefaultActiveKeys(value);
  }
  const addElement = (sectionName: string, valueName: string, cardholderValue?: any, cardHolderValues?: any) => {
    const isError = { value: false, message: '' };
    const productObj = { productKey };
    const formValues = form.getFieldsValue();
    const value = cardholderValue?.cardholder ?? formValues[sectionName][valueName]?.trim();
    const sectionValue = Object.entries({ ...productObj, ...formValues[sectionName], ...cardholderValue }).flat();
    const generateId = sectionValue?.map((element: any) => element?.trim()).join('-');
    const allProducts = Object.values(allProductsLists || {})?.flat();
    const checkValueIfItsstring = /^[a-zA-Z ]*$/.test(value);

    const parentId = sectionValue
      ?.slice(0, -2)
      ?.map((element: any) => element?.trim())
      ?.join('-')
      ? sectionValue?.slice(0, -2)?.join('-')?.trim()
      : null;
    const checkIfValueAlreadyExist = productList
      ?.filter((element: any) => parentId === element?.parentId)
      ?.filter((item: any) => item?.type === valueName && item?.name === value);
    const { parentCardholdersNumber }: any = cardholdersValidatior({ parentId, generateId, productList });
    const parentName = parentId?.split('-') || [];
    const checkIfLeafChanged = leafNodesHaveNocardholders?.[productKey]?.find(
      (item: any) => item?.uniqueId === parentId,
    );

    if (checkIfLeafChanged) {
      const newproductLeafList = leafNodesHaveNocardholders?.[productKey]?.filter(
        (item: any) => item?.uniqueId !== parentId,
      );
      dispatch(setEditLeafeNodes<any>({ newproductLeafList, productKey }));
    }
    if (parentCardholdersNumber >= 100 && productKey === 'CORPORATE_EXECUTIVE_CARD' && valueName === 'cardholder') {
      return { value: true, message: 'maximum cardholders is 100' };
    }
    if (
      parentCardholdersNumber >= 2 &&
      (productKey === 'DIGITAL_TRAVEL_PAYMENT' || productKey === 'DIGITAL_BUSINESS_PAYMENT') &&
      valueName === 'cardholder'
    ) {
      return {
        value: true,
        message: `maximum cardholders is 2 under this ${parentName[parentName.length - 3]} ${
          parentName[parentName.length - 2]
        }`,
      };
    }
    if (!checkIfValueAlreadyExist?.length && value && checkValueIfItsstring && !cardHolderValues) {
      const customObj = selectedProducts?.reduce((acc: any, curr: any) => {
        const reGeneratId = generateId?.replace(productKey, curr?.id);
        const reParentId = parentId?.replace(productKey, curr?.id) || null;
        const newProductList = productList?.map((item: any) => {
          return {
            ...item,
            parentId: item?.parentId?.replace(productKey, curr?.id) || null,
            uniqueId: item?.uniqueId?.replace(productKey, curr?.id),
            key: item?.key?.replace(productKey, curr?.id),
            name: item?.name?.replace(productKey, curr?.id),
          };
        });

        acc[curr.id] = [
          ...newProductList,
          {
            uniqueId: cardHolderValues ? `${reGeneratId}-${uuid()}` : reGeneratId,
            key: generateId,
            parentId: reParentId || null,
            name: value,
            type: valueName,
            title: (
              <TreeTitle
                productKey={curr?.id}
                nodeKey={reGeneratId}
                value={value}
                valueName={valueName}
                productLocked={productLocked}
              />
            ),
            cardHolderValues: cardHolderValues ?? undefined,
          },
        ];

        return acc;
      }, {});
      setProductsList((prev: any) => {
        return {
          ...prev,
          ...customObj,
        };
      });
      setCalldraft(true);
    } else if (!checkIfValueAlreadyExist?.length && value && checkValueIfItsstring) {
      const newProductList = [
        ...productList,
        {
          uniqueId: cardHolderValues ? `${generateId}-${uuid()}` : generateId,
          key: generateId,
          parentId: parentId || null,
          name: value,
          type: valueName,
          title: (
            <TreeTitle
              productKey={productKey}
              nodeKey={generateId}
              value={value}
              valueName={valueName}
              productLocked={productLocked}
            />
          ),
          cardHolderValues: cardHolderValues ?? undefined,
        },
      ];
      setProductsList((prev: any) => {
        return { ...prev, [productKey]: newProductList };
      });
      setCalldraft(true);
    } else {
      isError.value = true;
      if (!value) {
        isError.message = `${valueName} name is empty`;
      } else if (checkIfValueAlreadyExist?.length) {
        isError.message = `${valueName} name is already exist`;
      } else if (!checkValueIfItsstring) {
        isError.message = ` Text only is allowed`;
      }
    }
    return { ...isError };
  };

  function checkCardholderValidation(sectionName: string, valueName: string, cardholderValue?: any) {
    const isError = { value: false, message: '' };
    const productObj = { productKey };
    const formValues = form.getFieldsValue();
    const value = cardholderValue?.cardholder ?? formValues[sectionName][valueName]?.trim();
    const sectionValue = Object.entries({ ...productObj, ...formValues[sectionName], ...cardholderValue }).flat();
    const generateId = sectionValue?.map((element: any) => element?.trim()).join('-');
    const allProducts = Object.values(allProductsLists || {})?.flat();
    const parentId = sectionValue
      ?.slice(0, -2)
      ?.map((element: any) => element?.trim())
      ?.join('-')
      ? sectionValue?.slice(0, -2)?.join('-')?.trim()
      : null;
    const checkIfValueAlreadyExist = productList
      ?.filter((element: any) => parentId === element?.parentId)
      ?.filter((item: any) => item?.type === valueName && item?.name === value);
    const { parentCardholdersNumber }: any = cardholdersValidatior({ parentId, generateId, productList });
    const parentName = parentId?.split('-') || [];

    if (parentCardholdersNumber >= 100 && productKey === 'CORPORATE_EXECUTIVE_CARD' && valueName === 'cardholder') {
      return { value: true, message: 'maximum cardholders is 100' };
    }
    if (
      parentCardholdersNumber >= 2 &&
      (productKey === 'DIGITAL_TRAVEL_PAYMENT' || productKey === 'DIGITAL_BUSINESS_PAYMENT') &&
      valueName === 'cardholder'
    ) {
      return {
        value: true,
        message: `maximum cardholders is 2 under this ${parentName[parentName.length - 3]} ${
          parentName[parentName.length - 2]
        }`,
      };
    }
    if (!value) {
      isError.value = true;
      isError.message = `${valueName} name is empty`;
    } else if (checkIfValueAlreadyExist?.length) {
      isError.value = true;
      isError.message = `${valueName} name is already exist`;
    }
    return { ...isError };
  }
  function addParentNode({ company }: any) {
    const newProductList = [
      ...(productList || {}),
      {
        uniqueId: `productKey-${productKey}-company-${company}`,
        key: `company-${company}`,
        parentId: null,
        name: company,
        type: 'company',
        title: (
          <TreeTitle
            productKey={productKey}
            nodeKey={`company-${company}`}
            value={company}
            valueName="company"
            productLocked={productLocked}
          />
        ),
      },
    ];
    setProductsList((prev: any) => {
      return { ...prev, [productKey]: newProductList };
    });
  }

  function expandHandler(node: any) {
    if (!node.expanded) {
      const newExpandedKeys = defaultTreeKeys.filter((item: any) => item !== node?.node?.key);
      setDefaultTreeKeys(newExpandedKeys);
    } else {
      setDefaultTreeKeys((prev: any) => [...prev, node?.node?.key]);
    }
  }
  useEffect(() => {
    setIsError({ value: false, message: '' });
  }, [defaultActiveKeys]);

  function PanelSection(props: any) {
    const { productList, productKey, defaultActiveKeys, allProductsLists } = props;
    const { t } = useTranslation();
    return predefiendHierarchy?.map((item: any, index: number, predefinedArr: string[]) => {
      const selectionArr = predefinedArr.slice(0, index + 1);
      const typeToCheck = selectionArr[selectionArr?.length - 2];
      const isItdisabled = productList?.filter((item: any) => item.type === typeToCheck)?.length;
      const collabseKey = `${productKey}-${item}-${typeToCheck}-${isItdisabled}-Collapse`;
      const isItPhysical = physicalCards.includes(productKey);

      if (productLocked && item !== 'cardholder') {
        return <></>;
      }

      if (item !== 'company') {
        return (
          <AntForm
            key={`${productKey}-${item}-${typeToCheck}-${isItdisabled}-AntForm`}
            onFieldsChange={onValueChange}
            form={form}
            name={`${productKey}-panel`}
          >
            <CollapseContainer
              key={`${collabseKey}-CollapseContainer`}
              collabseKey={collabseKey}
              defaultActiveKeys={defaultActiveKeys}
              isItlast={defaultActiveKeys?.includes(`${productKey}-${item}-${typeToCheck}-${isItdisabled}-Panel`)}
            >
              <Collapse
                key={collabseKey}
                collapsible={!isItdisabled || applicationStage !== 'fillApplication' ? 'disabled' : undefined}
                accordion
                bordered={false}
                className="custom-Collapse"
                expandIcon={() => {
                  const isOpened = defaultActiveKeys?.includes(
                    `${productKey}-${item}-${typeToCheck}-${isItdisabled}-Panel`,
                  );
                  return !isOpened ? (
                    <PlusIcon style={{ position: 'absolute', top: '30%', fontSize: '16px' }} id="plusIconCard" />
                  ) : (
                    <MinusOutlined style={{ position: 'absolute', top: '30%', fontSize: '16px' }} id="plusIconCard" />
                  );
                }}
                activeKey={defaultActiveKeys}
                onChange={(value: any) => defaultKeyHandler(value)}
              >
                <Panel
                  key={`${productKey}-${item}-${typeToCheck}-${isItdisabled}-Panel`}
                  className="custom-Panel"
                  header={
                    <HeaderContainer isItdisabled={isItdisabled}>
                      <p
                        key={`${productKey}-${item}-${typeToCheck}-${isItdisabled}-PanelText`}
                        className="custom-panelHeader"
                      >
                        {' '}
                        Add{' '}
                        {!isItPhysical && item === 'cardholder'
                          ? t('Custodian Name')
                          : `${item[0].toUpperCase()}${item.slice(1)}`}
                      </p>
                    </HeaderContainer>
                  }
                >
                  <Space
                    style={{
                      width: '100%',
                      marginLeft: '6px',
                      marginTop: '6px',
                      // paddingTop: '-30px',
                      // margin: '0px',
                      display: 'flex',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Row justify="center" gutter={10}>
                      {selectionArr?.map((ele: any, index: number, selection: any) => {
                        const isItLast = index === selection?.length - 1;
                        const key = index + 1;
                        if (isItLast) {
                          const initialValue = productList?.find((item: any) => item.type === 'company')?.name;
                          return (
                            <Col>
                              <InputTreeElement
                                allProductsLists={allProductsLists}
                                setIsError={setIsError}
                                isError={isError}
                                sectionValues={form.getFieldsValue()}
                                form={form}
                                key={`${productKey}-${item}-${ele}-InputTreeElement`}
                                initialValue={ele === 'company' ? initialValue : undefined}
                                setCardholderModal={setCardholderModal}
                                item={item}
                                ele={ele}
                                addElement={addElement}
                                productKey={productKey}
                              />
                            </Col>
                          );
                        }
                        return (
                          <Col>
                            <SelectInputTree
                              productKey={productKey}
                              Form={AntForm}
                              form={form}
                              key={`${productKey}-${item}-${ele}-SelectInputTree`}
                              ele={ele}
                              item={item}
                              predefiendHierarchy={predefiendHierarchy}
                              productList={productList}
                            />
                          </Col>
                        );
                      })}
                    </Row>
                  </Space>
                </Panel>
              </Collapse>
            </CollapseContainer>
          </AntForm>
        );
      }
      return <></>;
    });
  }

  useEffect(() => {
    if (editedNodeDetails?.type && nodeDetails) {
      const checkIfValueAlreadyExist = productList
        ?.filter((element: any) => nodeDetails?.parentId === element?.parentId)
        ?.filter((item: any) => item?.type === nodeDetails?.type && item?.name === editedNodeDetails?.value);

      if (!checkIfValueAlreadyExist?.length) {
        const oldId = nodeDetails?.uniqueId?.split('-')?.slice(2)?.join('-');
        const splitedoldId = oldId.split('-');
        splitedoldId[splitedoldId.length - 1] =
          editedNodeDetails?.type === 'cardholder' ? editedNodeDetails?.values.name : editedNodeDetails?.value;
        const newId = splitedoldId.join('-');
        ///
        const preEditedProductsLists = Object?.entries(allProductsLists || {})?.map(([key, value]: any) => {
          const productEditedArr = value?.map((item: any) => {
            if (item.uniqueId?.split('-')?.slice(2)?.join('-') === oldId) {
              const newIdCross = ['productKey', key, newId].join('-');

              if (editedNodeDetails?.type === 'cardholder') {
                return {
                  ...item,
                  key: newIdCross,
                  uniqueId: newIdCross,
                  name: editedNodeDetails?.values.lastName
                    ? `${editedNodeDetails?.values.firstName} ${editedNodeDetails?.values.lastName}`
                    : editedNodeDetails?.values.nameOfVirtualCardAccount,
                  cardHolderValues: editedNodeDetails?.values,
                };
              } else {
                return { ...item, key: newIdCross, uniqueId: newIdCross, name: editedNodeDetails?.value };
              }
            } else if (item.uniqueId.includes(oldId)) {
              return {
                ...item,
                key: item?.uniqueId.replace(oldId, newId),
                uniqueId: item?.uniqueId.replace(oldId, newId),
                parentId: item?.parentId ? item.parentId.replace(oldId, newId) : null,
              };
            } else {
              return item;
            }
          });
          return { [key]: productEditedArr };
        });
        const newlists = Object.assign({}, ...preEditedProductsLists);
        setProductsList(() => {
          return newlists;
        });
        form.resetFields();
        setCalldraft(true);
        dispatch(setEditedNodeDetails<any>(null));
        dispatch(setNodeDetails<any>(null));
      } else {
        message.error(`${editedNodeDetails?.type} name is exist`);
        dispatch(setNodeDetails<any>(null));
      }
    }
  }, [JSON.stringify(editedNodeDetails)]);

  async function deletedCardholderHandler(deletedCardholder: any) {
    for (let i = 0; i < deletedCardholder.length; i++) {
      const cardholderId = deletedCardholder[i]?.cardHolderValues?.id;
      if (cardholderId) {
        await deleteCardholder({
          cardholderId,
          role: productKey === 'CORPORATE_EXECUTIVE_CARD' ? 'cardholder' : 'businessCardholder',
        });
      }
    }
  }

  useEffect(() => {
    if (deleteNode) {
      const removedId = nodeDetails.uniqueId?.split('-')?.slice(2)?.join('-');

      const deletedCardholder = allProductsLists?.[productKey]?.filter(
        (item: any) => item.uniqueId.includes(removedId) && item.type === 'cardholder' && item.cardHolderValues,
      );
      if (deletedCardholder?.length) {
        deletedCardholderHandler(deletedCardholder);
      }
      const predDeletedProductsLists = Object?.entries(allProductsLists || {})?.map(([key, value]: any) => {
        const filteredList = value?.filter((item: any) => !item.uniqueId.includes(removedId));
        return { [key]: filteredList };
      });
      const newlists = Object.assign({}, ...predDeletedProductsLists);
      setProductsList(() => {
        return newlists;
      });
      setDefaultActiveKeys([]);
      dispatch(setNodeDetails<any>(null));
      dispatch(setDeleteNode<any>(false));
      setCalldraft(true);
      form.resetFields();
    }
  }, [deleteNode]);

  useEffect(() => {
    setTreeData(getInitialTree(productList));
    const expandedKeys = productList?.map((item: any) => item?.key);
    setDefaultTreeKeys(expandedKeys);
  }, [productList]);

  function onValueChange(value: any, value2: any) {
    if (!value[0]?.name[0].includes(value[0]?.name[1])) {
      const endElement = predefiendHierarchy.indexOf(value[0]?.name[0].split('-')[0]);
      const startElement = Number(predefiendHierarchy.indexOf(value[0]?.name[1])) + Number(1);
      const elementHaveToClear = predefiendHierarchy.slice(startElement, endElement);
      for (let i = 0; i < elementHaveToClear.length; i++) {
        form.setFieldsValue({
          [value[0]?.name[0]]: {
            [elementHaveToClear[i]]: '',
          },
        });
      }
    }
  }

  useEffect(() => {
    const companyFromHierarchy = productList?.find((re: any) => re?.type === 'company')?.name;
    const company =
      companyFromHierarchy ||
      applicationQuery?.data?.payload?.companyInformation?.companyLicense?.legalName ||
      'Legal Company Name Test';
    for (let i = 0; i < ['company', ...predefiendHierarchy].length; i++) {
      form.setFieldsValue({
        [`${predefiendHierarchy[i]}-section`]: {
          company,
        },
      });
    }
    if (!productList?.filter((re: any) => re.type === 'company')?.length && !productList?.length) {
      addParentNode({ company });
    }
  }, [productList]);

  return (
    <Container predefiendHierarchy={predefiendHierarchy}>
      <div style={{ marginBottom: '24px' }}>
        {!!treeData?.length && productList?.length && (
          <Tree
            onSelect={(value: any, value2: any) => {
              dispatch(setNodeDetails(value2?.node));
            }}
            onExpand={(value, value2) => expandHandler(value2)}
            expandedKeys={defaultTreeKeys}
            key={productKey}
            style={{ backgroundColor: 'white' }}
            treeData={treeData}
          />
        )}
      </div>
      <div className="panelSectionStyle">
        <div className="panelSectionTitle">
          <Typography.Title level={5}>Build Your Hierarchy</Typography.Title>
        </div>
        <PanelSection
          allProductsLists={allProductsLists}
          defaultActiveKeys={defaultActiveKeys}
          productKey={productKey}
          setProductsList={setProductsList}
          productList={productList}
        />
      </div>
      <CardHolderModal
        addElement={addElement}
        openCardholderModal={openCardholderModal}
        setCardholderModal={setCardholderModal}
        checkCardholderValidation={checkCardholderValidation}
        allProductsLists={allProductsLists}
      />
      {editCardholderModal && nodeDetails?.uniqueId?.includes(productKey) && (
        <CardHolderEditModal
          isModalOpen={editCardholderModal}
          allProductsLists={allProductsLists}
          productKey={productKey}
        />
      )}
    </Container>
  );
};

const Container = styled.div<any>`
  .panelSectionStyle {
    margin-top: 80px;
    border: 1px solid ${colors.grey[300]};
    padding: 20px;
    padding-top: 40px;
    position: relative;
  }
  .panelSectionTitle {
    position: absolute;
    color: ${colors.blue[1100]};
    top: -10px;
    left: 38%;
    background-color: white;
  }
`;
const HeaderContainer = styled.div<any>`
  .custom-panelHeader {
    color: ${({ isItdisabled }) => {
      if (!isItdisabled) {
        return '#acacac';
      }
      return '#615d5d';
    }};
    align-self: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    margin-bottom: 15px;
    margin-left: 40px;
  }
`;
const CollapseContainer = styled.div<any>`
  margin-top: 0px;
  .ant-collapse-content-box {
    border-radius: 0px !important;
    border-top: 0px !important;
  }
  .ant-collapse-content ant-collapse-content-activ {
    border-width: 0px !important;
    background-color: green;
  }
  .custom-Collapse {
    background-color: green;
  }
  .validationInput {
    display: none;
  }
  .custom-input {
    background-color: white;
    height: 40px;
  }
  .ant-select-lg .ant-select-selector {
    height: 40px !important;
    display: flex;
    align-self: center;
    align-items: center;
    align-content: center;
  }

  input::placeholder {
    color: var(--text-body, #1b1b20);
    font-family: Gotham;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  .ant-collapse-header {
    border: 0.5px solid #cdcdce;
    border-radius: 18px;
    border-bottom-width: ${({ isItlast }: any) => {
      if (isItlast) {
        return 0;
      }
      return 1;
    }}px;
    background: #fff;
    display: flex;
    height: 42px;
  }
  .ant-collapse-content-box {
    border: 1px solid #cdcdce;
    border-radius: 8px;
    background: #fff;
    /* display: flex; */
    /* height: 90px; */
    /* padding: 0px 0px 0px 0px; */

    flex-shrink: 0;
  }
  .ant-space-item {
    margin-top: 0px !important;
  }
`;
export default TreeChildren;
